import { useApiClient } from "@hostingbv/lib/src/api";
import { Input } from "@hostingbv/lib/src/components/form/Input";
import { PillSelect } from "@hostingbv/lib/src/components/form/PillSelect";
import { Paragraph } from "@hostingbv/lib/src/components/Paragraph";
import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useCallback, useState } from "react";
import { config } from "../config";
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";
import { ContactType } from "@hostingbv/lib/src/api/common/models/Contact";

export const AddCustomerContactModal: FC<{ customer: Customer }> = props => {

  const [type, setType] = useState('internal')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [error, setError] = useState('')

  const { partnerClient } = useApiClient(config)

  const save = useCallback(async () => {
    await partnerClient.createCustomerContact(props.customer.id, {
      type: type,
      first_name: firstName,
      last_name: lastName,
      email: email,
      ...(type === "internal" ? {} : {
        phone: phone,
      })
    }).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
    })
  }, [type, firstName, lastName, email, phone, props.customer])

  return <>
    <form onSubmit={() => save()} className={"space-y-4 flex-1"}>
      <div className={"flex items-center max-w-md space-x-4"}>
        <PillSelect value={type} options={{
          'primary': 'Primary',
          'financial': 'Financial',
          'technical': 'Technical',
          'security': 'Security',
          'internal': 'Internal',
        }} onChange={(v) => setType(v as ContactType)} />
      </div>
      <div className={'max-w-md'}>
        <Paragraph>
          Internal contacts cannot be selected as WHOIS contacts for domains, but they can be used to grant login access, manage SSH keys, and more.
        </Paragraph>
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"First name"} type={"text"} value={firstName} onChange={(v) => setFirstName(v)} />
        <Input label={"Last name"} type={"text"} value={lastName} onChange={(v) => setLastName(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Email"} type={"text"} value={email} onChange={(v) => setEmail(v)} />
      </div>
      {type !== 'internal' && <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Phone"} type={"text"} value={phone ?? ''} onChange={(v) => setPhone(v)} />
      </div>}
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Save"} onSubmit={save} />
  </>
}
